import React from 'react';
import styles from '../../static/css/pages.module.css';
import Title from "../../components/title/title";

class ServerWaiting extends React.Component {
  render() {
    return (
      <div className={styles.content}>
        <div>
          <div className="l-grid_pt-8 mobile_l-grid">
            <div className="l-grid__item_1"></div>
            <div className="l-grid__item_6 mobile_l-grid__item_10">
              <Title icon={this.props.pageIcon} title={this.props.pageTitle}/>
              <div className={`${styles.loadingEl} ${styles.loadingInner}`}>
                <div className={styles.loader}></div>
                {this.props.waiting}
              </div>
              <div className={styles.article}>&nbsp;</div>
              <div className={styles.article}>&nbsp;</div>
              <div className={styles.article}>&nbsp;</div>
            </div>
          </div>
        </div>
        <div id="preloader"></div>
      </div>
    )
  }
}

export default ServerWaiting;
